var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ONE-TIME-CODE"},[_c('div',{staticClass:"text-left"},[_c('router-link',{staticClass:"link-black",attrs:{"to":{
          name: 'one-time-code',
          query: {
            redirectTo: _vm.redirectTo,
          },
        }}},[_c('vk-icon',{staticClass:"c-depot",attrs:{"name":"chevronleft"}}),_vm._v("Back\n    ")],1)],1),_c('one-time-code-sign-in-form'),_vm._v("\n  Already have an account?\n  "),_c('router-link',{staticClass:"link",attrs:{"to":{
        name: 'login',
        query: {
          redirectTo: _vm.redirectTo,
        }
      }}},[_vm._v("\n    Sign in with password.\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }